require('./club-scorecard.jade')
_ = require("lodash")

class ClubScoreCardCtrl
  constructor: ($scope, @ClubService) ->
    @scorecards = []
    $scope.isShowYardage = false

    _.forEach $scope.$parent.clubInfo.courses, (course) =>
      @ClubService.getYardage(course.id).then (data) =>
        @scorecards.push {course: course, yardage: data}

    $scope.showYardage = ->
      $scope.isShowYardage = !$scope.isShowYardage

ClubScoreCardCtrl.$inject = [
  '$scope'
  'ClubService'
]

module.exports = ClubScoreCardCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-scorecard/club-scorecard-controller.coffee